<template>
    <div id="departments">
        <!-- <div style="height: 6px;"></div>
        <div style="padding: 6px;">
            <span style="font-size:16px;padding-left: 14px;">
                <i style="display: inline-block; width: 18px;height: 18px;position: relative;top: 3px;">
                    <img style="width: 100%;height: 100%;" src="@/assets/tag.png" alt="">
                </i>
                {{ $t('message.list.relatedItem') }}
            </span>
        </div> -->
        <div style="margin-top: 10px;margin-right: 20px;">
            <el-button class="btn btn1" icon="el-icon-circle-plus-outline" @click="searchAddRel = true"
                :disabled="!addTableListPriv" :class="!addTableListPriv ? 'btnDisable' : ''">{{ $t('message.button.add')
                }}
            </el-button>
            <el-button class="btn btn2" icon="el-icon-delete" @click="removeCheckbox" :disabled="!removeTableListPriv"
                :class="!removeTableListPriv ? 'btnDisable' : ''">{{ $t('message.button.delete') }}
            </el-button>
            <div class="edit-table" style="float: right;overflow: hidden;height: 33px;">
                <el-button class="btn btn3" icon="el-icon-document-checked" @click="getUpdateEvent" v-if="!editShow">{{
                    $t('message.button.save') }}
                </el-button>
                <el-button class="btn btn4" icon="el-icon-circle-close" @click="closeSave" v-if="!editShow">{{
                    $t('message.button.cancel') }}
                </el-button>
            </div>
        </div>
        <div style="padding: 10px 20px;">
            <!-- 表格区域 -->
            <vxe-grid ref='xGrid' v-bind="gridOptions" @cell-dblclick="noEdit" @checkbox-change="checkboxChangeEvent"
                @checkbox-all="checkboxChangeEvent">
                <template #bottom>
                    <div class="alert-message">
                        <span class="alert-message-content">
                            <div>已选中 {{ selectRecords.length }} 条 共 {{ totalRecords }} 条</div>
                        </span>
                    </div>
                </template>
            </vxe-grid>
        </div>
        <el-dialog class="searchAddBomList" v-if='searchAddRel' :title="$t('message.title.add')"
            :visible.sync="searchAddRel" :close-on-click-modal="false" :close-on-press-escape="false">
            <SearchQualityItem @listDbClick="addList"></SearchQualityItem>
        </el-dialog>
    </div>
</template>

<script>
//;
import SearchQualityItem from '@/components/searchQualityItem.vue'; //引进菜单模板
import axios from "axios";
export default {
    data() {
        return {
            searchAddRel: false, //添加窗口开关
            version: "",
            selectRecords: [],
            totalRecords: "",
            gridOptions: {
                keepSource: true,
                resizable: true,
                border: true,
                stripe: true,
                highlightHoverRow: true,
                highlightCurrentRow: true,
                showHeaderOverflow: true,
                showOverflow: true,
                autoResize: true,
                rowId: 'id',
                height: "530",
                size: "small",
                columns: [],
                data: [],
                treeConfig: {
                    lazy: true,
                    children: 'children',
                    hasChild: 'hasChildren',
                    loadMethod: this.loadChildrenMethod
                },
                editConfig: {
                    trigger: 'dblclick',
                    mode: 'cell',
                    showIcon: false,
                    activeMethod: this.activeRowMethod,
                    showStatus: true,
                },
                sortConfig: {
                    trigger: 'cell'
                },
            },
            editShow: false,
            workFlowStatus: true,//变更工作流状态
            loading: true,
            cols: [], //表头
            rols_text: [], //表体显示内容
            tableShow: false, //显示table
            get_change_info: "", //父组件传来的值
            addTableListPriv: false,
            removeTableListPriv: false,
            cascaderShow: false,
            cascaderValue: [],
            cascaderList: [],
            cascaderProps: {},
            cachePnameList: [],
        }
    },
    mounted() { },
    components: {
        SearchQualityItem,
    },
    methods: {
        checkboxChangeEvent({ records }) {
            const $grid = this.$refs.xGrid;
            this.selectRecords = records;
        },
        removeCheckbox() { //删除
            var change_info = this.$store.state.change_info;
            var removeRow = this.$refs.xGrid.getCheckboxRecords();
            var vm = this;
            if (removeRow.length == 0) {
                return false
            } else {
                let deletedRelatedItems = {
                    technologyObjId: {
                        ...this.$store.state.objectId,
                        version: 0,
                    },
                    changeObjId: {
                        id: change_info.changeId,
                        classId: change_info.changeClassId,
                        subClassId: change_info.changeSubClassId,
                    },
                    tableId: 24,
                };
                var del_table = [];
                for (var i = 0; i < removeRow.length; i++) {

                    del_table.push({ id: removeRow[i].rowId });
                }
                deletedRelatedItems.deletedRelatedItems = del_table;
                axios.post('/pmdm/technology/deleteTable', deletedRelatedItems).then(res => {
                    if (res.data.code == 200) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                        this.getRelInfo();
                    }
                })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        },
        addList(row) { //添加
            var change_info = this.$store.state.change_info;
            let insertItems = row.map((i) => {
                return {
                    itemId: i.itemId,
                };
            });
            var insertTechnology = {
                //post更改的值
                tableId: 24,
                technologyObjId: {
                    ...this.$store.state.objectId,
                    version: 0,
                },
                changeObjId: {
                    id: change_info.changeId,
                    classId: change_info.changeClassId,
                    subClassId: change_info.changeSubClassId,
                },
                insertItems: insertItems,
            };
            axios.post('/pmdm/technology/saveTable', insertTechnology)
                .then(res => {
                    console.log(res);
                    if (res.data.code == 200) {
                        this.$message({
                            message: res.data.message,
                            type: 'success'
                        });
                    };
                    this.getRelInfo();
                })
                .catch();
        },
        closeSave() {
            this.$refs.xGrid.revertData(); //清除所有保存，删除，添加记录
        },
        async noEdit({ row, column, columnIndex }) {
            var getIRL = {
                id: row.itemId,
                subClassId: row.itemSubClassId,
            };
            let subClsIdListId = this.gridOptions.columns[columnIndex];
            if (subClsIdListId.attid == "5014006") {
                const getItemRevListBySubclassUrl = `/pmdm/technology/getRevList${this.params(getIRL)}`;
                const { data: res } = await this.$http.get(getItemRevListBySubclassUrl);
                if (res.code == 200) {
                    var select_val = [];
                    var val = res.object.revList;
                    for (var key in val) {
                        if (!val[key].editable) continue;
                        var select_obj = {};
                        select_obj.label = val[key].val;
                        select_obj.value = val[key].id;
                        select_val.push(select_obj);
                    };
                    this.cachePnameList = this.cachePnameList.concat(select_val);
                    this.gridOptions.columns[columnIndex].editRender.options = select_val;
                }
            };
            if (column.editRender.cascaderType && this.editTable) {
                this.cascaderList = column.editRender.cascadeOptions;
                let m = row[[column.property]];
                if (column.editRender.props.multiple) {
                    this.cascaderValue = m ? m.map((i) => { return this.getParentIdList(this.cascaderList, i) }) : ''
                    this.cascaderProps.multiple = true;
                } else {
                    this.cascaderProps.multiple = false;
                    this.cascaderValue = m;
                }
                this.cascaderProps.checkStrictly = true;
                this.tempData = { row, column }
                this.cascaderShow = true;
            }
        },
        getUpdateEvent() {
            var change_info = this.$store.state.change_info;
            var xGrid_ = this.$refs.xGrid;
            var columns = this.gridOptions.columns;
            var cols_ = this.cols;
            let updateRecords = xGrid_.getUpdateRecords(); //获取修改的行
            var cols_length = cols_;
            var updateRel = [];
            if (updateRecords.length !== 0) {//判断行内那些值有改动
                for (let i = 0; i < updateRecords.length; i++) {
                    var num = xGrid_.getRowIndex(updateRecords[i]);
                    for (let j = 0; j < cols_length.length; j++) {
                        var updateNewData = xGrid_.isUpdateByRow(updateRecords[i], "" + j);
                        if (updateNewData) {
                            for (let k = 0; k < columns.length; k++) {
                                var obj = {};
                                if (cols_length[j] == columns[k].attid) {
                                    var quantity = cols_length[j];
                                    obj.id = updateRecords[i].rowId;
                                    if (columns[k].editRender.props) {//处理多选和单选
                                        if (columns[k].editRender.props.multiple) {
                                            obj[quantity] = updateRecords[i][j].join(";")
                                        } else if (columns[k].editRender.props.type == "datetime") {
                                            obj[quantity] = this.format(updateRecords[i][j], "yyyy-MM-ddThh:mm:ss");
                                            console.log(obj[quantity]);
                                        } else {
                                            if (updateRecords[i][j] == null) {
                                                obj[quantity] = "";
                                            } else {
                                                obj[quantity] = updateRecords[i][j];
                                            }
                                        }
                                    } else {
                                        if (updateRecords[i][j] == null) {
                                            obj[quantity] = "";
                                        } else {
                                            obj[quantity] = updateRecords[i][j];
                                        }
                                    };
                                    updateRel.push(obj);
                                }
                            }
                        }
                    }
                };
                var updateRelData = {//post更改的值
                    technologyObjId: {
                        ...this.$store.state.objectId,
                        version: 0,
                    },
                    changeObjId: {
                        id: change_info.changeId,
                        classId: change_info.changeClassId,
                        subClassId: change_info.changeSubClassId,
                    },
                    tableId: 24,
                    updateRelatedItems: this.ArrayFilter(updateRel)
                };
                axios.post('/pmdm/technology/updateTable', updateRelData)
                    .then(res => {
                        if (res.data.code == 200) {
                            this.$message({
                                message: res.data.message,
                                type: 'success'
                            });
                            this.getRelInfo();
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            };
        },
        ArrayFilter(l) {
            let arr = l
            let list = arr.reduce((pre, cur) => {
                let target = pre.find(ee => ee.id == cur.id)
                if (target) {
                    Object.assign(target, cur)
                } else {
                    pre.push(cur)
                }
                return pre
            }, [])
            return list
        },
        activeRowMethod({ row }) {
            return !row.disable
        },
        getRelInfo() {
            this.$emit('refreshTab');
            var change_info = this.$store.state.change_info;
            const { changeInfoNum = '[{}]' } = this.$route.query;
            const arr = JSON.parse(changeInfoNum)
            this.addTableListPriv = arr.length == 1;
            // this.addTableListPriv = this.$route.query.changeInfoNum.length == 1;
            this.removeTableListPriv = this.addTableListPriv;
            if (this.get_change_info == "") {
                change_info = this.$store.state.change_info;
            } else {
                change_info = this.get_change_info;
            };
            var obj_get = { //获取change
                ... this.$store.state.objectId,
                ...change_info,
                tableId: 24
            };
            var loadTableUrl = `/pmdm/technology/loadTable${this.params(obj_get)}`;
            axios.get(loadTableUrl).then(res => {
                this.gridOptions.columns = this.getNewTableTitleData(res.data);
                this.cols = res.data.object.table.columnInfo.ids;
                this.rols_text = this.getNewTableContentData(res.data);
                this.$refs.xGrid.loadData(this.rols_text);
                this.totalRecords = res.data.object.table.rows ? res.data.object.table.rows.length : res.data.object.table.totalRecords;
                this.tableShow = true;
                this.version = res.data.object.table.version;
                this.selectRecords = [];
            })
        },
        loadUserPriv() {
            var priv_ = this.getUserContextPriv();
            let subClass_Id = this.$store.state.objectId.subClassId;
            for (let i = 0; i < priv_.length; i++) {
                if (priv_[i].classId == subClass_Id) {
                    if (priv_[i].type == 3) {
                        this.addTableListPriv = true;
                    };
                    if (priv_[i].type == 4) {
                        this.removeTableListPriv = true;
                    };
                }
            };
            let isSupAdmin = this.$store.state.isSuperAdmin;
            if (isSupAdmin) {
                this.addTableListPriv = true;
                this.removeTableListPriv = true;
            };
        },
    },
    created() {

        this.loadUserPriv();
        this.getRelInfo();
        setTimeout(() => {
            this.loading = false;
        }, 500);
    },
    computed: {
        loadWorkFlowStatus() {
            return this.$store.state.changeWorkflowStatus;
        },
    },
    props: ['changeValue', 'relUrl', 'type'],
    watch: {
        changeValue: function (value) {
            this.get_change_info = value;
            this.getRelInfo();
        },
        loadWorkFlowStatus: {
            handler(val) {
                const { changeInfoNum = '[{}]' } = this.$route.query;
                const arr = JSON.parse(changeInfoNum)
                if (arr.length == 1) {
                    this.workFlowStatus = true;
                } else {
                    this.workFlowStatus = false
                };
            },
            deep: true,
            immediate: true,
        },
    }
};
</script>

<style>
.RelSearchAddBomList .el-dialog__body {
    padding: 0 20px 20px 20px !important;
}

.el-table th.gutter {
    display: table-cell !important;
}

.link_ {
    color: #4b92ff;
    cursor: pointer;
}

.link_:hover {
    color: #4b92ff;
    cursor: pointer;
    border-bottom: 1px solid #4b92ff;
}

.mytable-style .vxe-body--column.col-red {
    text-decoration: line-through;
    color: red;
}

.mytable-style .vxe-body--column.col-red span {
    color: #000;
}

.mytable-style .vxe-body--column.col-red-text {
    color: red;
}

.mytable-style .vxe-body--column.col-red-text span {
    color: red;
}
</style>

<style scoped>
.line-1 {
    height: 6px;
    background: #ebebeb;
}

.content-title {
    padding: 0;
    margin: 0;
    overflow: hidden;
    background-size: 100% 100%;
    height: 40px;
    margin-left: 20px;
}

.content-title li {
    float: left;
    padding: 8px 8px 8px 8px;
    font-size: 14px;
    cursor: pointer;
    margin-right: 18px;
}

.content-title li:hover {
    border-bottom: 3px solid #4b92ff;
    color: #4b92ff;
}

.content-title .active {
    border-bottom: 3px solid #4b92ff;
    color: #4b92ff;
}
</style>
